import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { EventItem } from '@shared';
import { Observable } from 'rxjs';
import * as EventsActions from './events.actions';
import * as EventsSelectors from './events.selectors';
import { EventsState } from './events.state';

@Injectable({
  providedIn: 'root',
})
export class EventsFacade {
  private store: Store<EventsState> = inject(Store<EventsState>);

  upcomingEvents$: Observable<EventItem[]> = this.store.select(EventsSelectors.selectUpcomingEvents);
  publicUpcomingEvents$: Observable<EventItem[]> = this.store.select(EventsSelectors.selectPublicUpcomingEvents);
  inPreparationEvents$: Observable<EventItem[]> = this.store.select(EventsSelectors.selectInPreparationEvents);
  publicInPreparationEvents$: Observable<EventItem[]> = this.store.select(EventsSelectors.selectPublicInPreparationEvents);
  pastEvents$: Observable<EventItem[]> = this.store.select(EventsSelectors.selectPastEvents);
  hasMoreUpcomingEvents$ = this.store.select(EventsSelectors.selectHasMoreUpcomingEvents);
  hasMoreInPreparationEvents$ = this.store.select(EventsSelectors.selectHasMoreInPreparationEvents);
  hasMorePastEvents$ = this.store.select(EventsSelectors.selectHasMorePastEvents);
  loading$: Observable<boolean> = this.store.select(EventsSelectors.selectEventsLoading);
  loadingMoreUpcomingEvents$ = this.store.select(EventsSelectors.selectLoadingMoreUpcomingEvents);
  loadingMoreInPreparationEvents$ = this.store.select(EventsSelectors.selectLoadingMoreInPreparationEvents);
  loadingMorePastEvents$: Observable<boolean> = this.store.select(EventsSelectors.selectLoadingMorePastEvents);
  error$: Observable<string | null> = this.store.select(EventsSelectors.selectEventsError);

  loadUpcomingEvents(page: number = 1, search?: string, tagIds?: string[], dateFrom?: string, dateTo?: string): void {
    this.store.dispatch(EventsActions.loadUpcomingEvents({ page, search, tagIds, dateFrom, dateTo }));
  }

  loadPastEvents(page: number = 1, search?: string, tagIds?: string[], dateFrom?: string, dateTo?: string): void {
    this.store.dispatch(EventsActions.loadPastEvents({ page, search, tagIds, dateFrom, dateTo }));
  }

  loadInPreparationEvents(page: number = 1, search?: string, tagIds?: string[], dateFrom?: string, dateTo?: string): void {
    this.store.dispatch(EventsActions.loadInPreparationEvents({ page, search, tagIds, dateFrom, dateTo }));
  }

  loadMorePastEvents(search?: string, tagIds?: string[], dateFrom?: string, dateTo?: string): void {
    this.store.dispatch(EventsActions.loadMorePastEvents({ search, tagIds, dateFrom, dateTo }));
  }

  loadMoreUpcomingEvents(search?: string, tagIds?: string[], dateFrom?: string, dateTo?: string): void {
    this.store.dispatch(EventsActions.loadMoreUpcomingEvents({ search, tagIds, dateFrom, dateTo }));
  }

  loadMoreInPreparationEvents(search?: string, tagIds?: string[], dateFrom?: string, dateTo?: string): void {
    this.store.dispatch(EventsActions.loadMoreInPreparationEvents({ search, tagIds, dateFrom, dateTo }));
  }
}
